import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import './style.css';

function Cancel(props) {
	const { user, dispatch } = props;

	useEffect(() => {
		const query = new URLSearchParams(window.location.search);

		if (query.get('canceled')?.toUpperCase() === 'TRUE') {
			dispatch({ type: 'LOGOUT' });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (user.isLoading) {
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	}
	return (
		<div>
			<section id='confirmationSection' className='confirmationSection'>
				<h1 className='confirmationHeader'>Sorry to see you go. Your subscription has now been cancelled.</h1>
				<a href='/' className='confirmationButton' title='Home'>
					HOME
				</a>
			</section>
		</div>
	);
}

const mapStateToProps = (state) => ({
	user: state.user,
	freeAccess: state.freeAccess,
	sources: state.sources,
	prices: state.prices
});

export default connect(mapStateToProps)(Cancel);
